import * as AT from '../actions/_types'

const initialState = {
  loading: false,
  error: null,
  generatedText: '',
}

export default function aiAssistant(state = initialState, action) {
  switch (action.type) {
    case AT.AI_ASSISTANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    
    case AT.AI_ASSISTANT_SUCCESS:
      return {
        ...state,
        loading: false,
        generatedText: action.generatedText,
      }
    
    case AT.AI_ASSISTANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    
    case AT.AI_ASSISTANT_CLEAR:
      return {
        ...state,
        generatedText: null,
      }
    
    default:
      return state
  }
} 



// WEBPACK FOOTER //
// ./src/state/reducers/ai-assistant.js